import type { Client, Project, Contract, TeamMember } from '@/types/entities';

// Team members pool
export const teamMembers: TeamMember[] = [
  { id: '1', name: 'Roman Siromskyi', role: 'Owner & Lead Developer' },
  { id: '2', name: 'Bohdan Buryi', role: 'Senior Developer' },
  { id: '3', name: 'Vlad Dev', role: 'Full-Stack Developer' },
  { id: '4', name: 'Bohdan Branovskyi', role: 'Frontend Developer' },
  { id: '5', name: 'Nastya Tishchenko', role: 'QA Engineer' },
];

// Mock Clients
export const mockClients: Client[] = [
  {
    id: 'client-1',
    companyName: 'TechCorp Solutions',
    contactPerson: 'John Smith',
    email: 'john.smith@techcorp.com',
    phone: '+1 (555) 123-4567',
    status: 'active',
    source: 'upwork',
    address: '123 Tech Street, San Francisco, CA 94105',
    website: 'https://techcorp.com',
    notes: 'Long-term client, prefers agile methodology',
    createdAt: '2024-01-15T10:00:00Z',
    updatedAt: '2025-10-02T15:30:00Z',
    totalRevenue: 125000,
    activeProjects: 2,
    totalProjects: 5,
  },
  {
    id: 'client-2',
    companyName: 'Global Innovations LLC',
    contactPerson: 'Sarah Johnson',
    email: 'sarah.j@globalinn.com',
    phone: '+1 (555) 987-6543',
    status: 'active',
    source: 'referral',
    address: '456 Innovation Ave, New York, NY 10001',
    website: 'https://globalinnovations.com',
    notes: 'Enterprise client, requires detailed documentation',
    createdAt: '2024-03-20T14:00:00Z',
    updatedAt: '2025-10-01T09:15:00Z',
    totalRevenue: 250000,
    activeProjects: 3,
    totalProjects: 7,
  },
  {
    id: 'client-3',
    companyName: 'StartupHub Inc',
    contactPerson: 'Mike Chen',
    email: 'mike@startuphub.io',
    phone: '+1 (555) 234-5678',
    status: 'lead',
    source: 'website',
    address: '789 Startup Lane, Austin, TX 78701',
    website: 'https://startuphub.io',
    notes: 'Interested in MVP development, budget-conscious',
    createdAt: '2025-09-15T11:00:00Z',
    updatedAt: '2025-09-28T16:45:00Z',
    totalRevenue: 0,
    activeProjects: 0,
    totalProjects: 0,
  },
  {
    id: 'client-4',
    companyName: 'Enterprise Systems Co',
    contactPerson: 'Amanda White',
    email: 'amanda.white@entsys.com',
    phone: '+1 (555) 345-6789',
    status: 'active',
    source: 'linkedin',
    address: '321 Business Blvd, Chicago, IL 60601',
    website: 'https://enterprisesystems.com',
    notes: 'Fortune 500 client, high priority',
    createdAt: '2023-11-10T08:00:00Z',
    updatedAt: '2025-09-30T14:20:00Z',
    totalRevenue: 450000,
    activeProjects: 1,
    totalProjects: 12,
  },
  {
    id: 'client-5',
    companyName: 'Digital Ventures',
    contactPerson: 'Robert Garcia',
    email: 'robert@digitalventures.com',
    phone: '+1 (555) 456-7890',
    status: 'inactive',
    source: 'upwork',
    address: '654 Digital Way, Seattle, WA 98101',
    website: 'https://digitalventures.com',
    notes: 'Completed all projects, may return in Q4',
    createdAt: '2023-06-05T12:00:00Z',
    updatedAt: '2025-05-15T10:00:00Z',
    totalRevenue: 85000,
    activeProjects: 0,
    totalProjects: 3,
  },
  {
    id: 'client-6',
    companyName: 'CloudFirst Technologies',
    contactPerson: 'Lisa Brown',
    email: 'lisa.brown@cloudfirst.tech',
    phone: '+1 (555) 567-8901',
    status: 'active',
    source: 'referral',
    address: '987 Cloud Street, Boston, MA 02101',
    website: 'https://cloudfirst.tech',
    notes: 'Cloud migration specialist, recurring work',
    createdAt: '2024-07-22T09:00:00Z',
    updatedAt: '2025-10-03T08:30:00Z',
    totalRevenue: 175000,
    activeProjects: 2,
    totalProjects: 4,
  },
  {
    id: 'client-7',
    companyName: 'RetailMax Group',
    contactPerson: 'David Martinez',
    email: 'david.m@retailmax.com',
    status: 'lead',
    source: 'other',
    notes: 'Trade show contact, discussing e-commerce platform',
    createdAt: '2025-09-20T13:00:00Z',
    updatedAt: '2025-09-25T11:30:00Z',
    totalRevenue: 0,
    activeProjects: 0,
    totalProjects: 0,
  },
  {
    id: 'client-8',
    companyName: 'FinanceFlow Solutions',
    contactPerson: 'Emily Taylor',
    email: 'emily@financeflow.com',
    phone: '+1 (555) 678-9012',
    status: 'active',
    source: 'linkedin',
    address: '147 Finance Plaza, Miami, FL 33101',
    website: 'https://financeflow.com',
    notes: 'FinTech client, security-focused',
    createdAt: '2024-02-14T10:00:00Z',
    updatedAt: '2025-10-02T12:15:00Z',
    totalRevenue: 320000,
    activeProjects: 3,
    totalProjects: 8,
  },
];

// Mock Projects
export const mockProjects: Project[] = [
  {
    id: 'project-1',
    name: 'E-Commerce Platform Redesign',
    description: 'Complete redesign and modernization of the e-commerce platform with new features',
    clientId: 'client-1',
    clientName: 'TechCorp Solutions',
    status: 'in-progress',
    priority: 'high',
    managerId: '1',
    managerName: 'Roman Siromskyi',
    teamMembers: [teamMembers[0]!, teamMembers[1]!, teamMembers[3]!],
    budget: 75000,
    actualCost: 45000,
    progress: 60,
    startDate: '2025-08-01T00:00:00Z',
    estimatedEndDate: '2025-11-30T00:00:00Z',
    tags: ['e-commerce', 'frontend', 'ui-redesign'],
    createdAt: '2025-07-15T10:00:00Z',
    updatedAt: '2025-10-02T14:30:00Z',
  },
  {
    id: 'project-2',
    name: 'Mobile App Development',
    description: 'Native mobile application for iOS and Android with real-time features',
    clientId: 'client-2',
    clientName: 'Global Innovations LLC',
    status: 'planning',
    priority: 'high',
    managerId: '2',
    managerName: 'Bohdan Buryi',
    teamMembers: [teamMembers[1]!, teamMembers[2]!],
    budget: 120000,
    actualCost: 15000,
    progress: 15,
    startDate: '2025-10-15T00:00:00Z',
    estimatedEndDate: '2026-03-31T00:00:00Z',
    tags: ['mobile', 'react-native', 'api'],
    createdAt: '2025-09-20T09:00:00Z',
    updatedAt: '2025-10-03T10:15:00Z',
  },
  {
    id: 'project-3',
    name: 'Legacy System Migration',
    description: 'Migrate legacy monolithic application to microservices architecture',
    clientId: 'client-4',
    clientName: 'Enterprise Systems Co',
    status: 'in-progress',
    priority: 'critical',
    managerId: '1',
    managerName: 'Roman Siromskyi',
    teamMembers: [teamMembers[0]!, teamMembers[1]!, teamMembers[2]!, teamMembers[4]!],
    budget: 200000,
    actualCost: 120000,
    progress: 55,
    startDate: '2025-06-01T00:00:00Z',
    estimatedEndDate: '2025-12-31T00:00:00Z',
    tags: ['backend', 'microservices', 'migration', 'devops'],
    createdAt: '2025-05-10T08:00:00Z',
    updatedAt: '2025-10-02T16:45:00Z',
  },
  {
    id: 'project-4',
    name: 'Analytics Dashboard',
    description: 'Real-time analytics dashboard with custom reporting and data visualization',
    clientId: 'client-1',
    clientName: 'TechCorp Solutions',
    status: 'review',
    priority: 'medium',
    managerId: '3',
    managerName: 'Vlad Dev',
    teamMembers: [teamMembers[2]!, teamMembers[3]!],
    budget: 35000,
    actualCost: 32000,
    progress: 95,
    startDate: '2025-07-15T00:00:00Z',
    endDate: '2025-09-30T00:00:00Z',
    estimatedEndDate: '2025-09-30T00:00:00Z',
    tags: ['frontend', 'analytics', 'dashboard'],
    createdAt: '2025-07-01T12:00:00Z',
    updatedAt: '2025-09-30T11:20:00Z',
  },
  {
    id: 'project-5',
    name: 'Cloud Migration',
    description: 'Migrate on-premise infrastructure to AWS cloud with high availability setup',
    clientId: 'client-6',
    clientName: 'CloudFirst Technologies',
    status: 'in-progress',
    priority: 'high',
    managerId: '2',
    managerName: 'Bohdan Buryi',
    teamMembers: [teamMembers[1]!, teamMembers[2]!],
    budget: 85000,
    actualCost: 50000,
    progress: 70,
    startDate: '2025-08-01T00:00:00Z',
    estimatedEndDate: '2025-11-15T00:00:00Z',
    tags: ['cloud', 'aws', 'devops', 'infrastructure'],
    createdAt: '2025-07-20T09:00:00Z',
    updatedAt: '2025-10-01T15:30:00Z',
  },
  {
    id: 'project-6',
    name: 'Payment Gateway Integration',
    description: 'Integrate multiple payment gateways with fraud detection and reporting',
    clientId: 'client-8',
    clientName: 'FinanceFlow Solutions',
    status: 'completed',
    priority: 'high',
    managerId: '1',
    managerName: 'Roman Siromskyi',
    teamMembers: [teamMembers[0]!, teamMembers[1]!, teamMembers[4]!],
    budget: 55000,
    actualCost: 52000,
    progress: 100,
    startDate: '2025-06-01T00:00:00Z',
    endDate: '2025-08-31T00:00:00Z',
    estimatedEndDate: '2025-08-31T00:00:00Z',
    tags: ['backend', 'payment', 'fintech', 'api'],
    createdAt: '2025-05-15T10:00:00Z',
    updatedAt: '2025-08-31T17:00:00Z',
  },
  {
    id: 'project-7',
    name: 'CRM System Enhancement',
    description: 'Add custom features and automation to existing CRM system',
    clientId: 'client-2',
    clientName: 'Global Innovations LLC',
    status: 'on-hold',
    priority: 'low',
    managerId: '3',
    managerName: 'Vlad Dev',
    teamMembers: [teamMembers[2]!],
    budget: 25000,
    actualCost: 8000,
    progress: 30,
    startDate: '2025-08-15T00:00:00Z',
    estimatedEndDate: '2026-01-31T00:00:00Z',
    tags: ['crm', 'automation', 'backend'],
    createdAt: '2025-08-01T11:00:00Z',
    updatedAt: '2025-09-15T13:45:00Z',
  },
  {
    id: 'project-8',
    name: 'Security Audit & Hardening',
    description: 'Comprehensive security audit and implementation of security best practices',
    clientId: 'client-8',
    clientName: 'FinanceFlow Solutions',
    status: 'in-progress',
    priority: 'critical',
    managerId: '1',
    managerName: 'Roman Siromskyi',
    teamMembers: [teamMembers[0]!, teamMembers[4]!],
    budget: 40000,
    actualCost: 25000,
    progress: 65,
    startDate: '2025-09-01T00:00:00Z',
    estimatedEndDate: '2025-10-31T00:00:00Z',
    tags: ['security', 'audit', 'compliance'],
    createdAt: '2025-08-20T09:00:00Z',
    updatedAt: '2025-10-02T10:30:00Z',
  },
];

// Mock Contracts
export const mockContracts: Contract[] = [
  {
    id: 'contract-1',
    contractNumber: 'LWM-2025-001',
    clientId: 'client-1',
    clientName: 'TechCorp Solutions',
    projectId: 'project-1',
    projectName: 'E-Commerce Platform Redesign',
    type: 'fixed-price',
    status: 'active',
    totalValue: 75000,
    paidAmount: 45000,
    startDate: '2025-08-01T00:00:00Z',
    endDate: '2025-11-30T00:00:00Z',
    signedDate: '2025-07-28T00:00:00Z',
    deliverables: [
      {
        id: 'del-1',
        title: 'UI/UX Design',
        description: 'Complete design system and mockups',
        dueDate: '2025-08-31T00:00:00Z',
        status: 'completed',
      },
      {
        id: 'del-2',
        title: 'Frontend Development',
        description: 'Implementation of all frontend features',
        dueDate: '2025-10-15T00:00:00Z',
        status: 'in-progress',
      },
      {
        id: 'del-3',
        title: 'Testing & Deployment',
        description: 'QA testing and production deployment',
        dueDate: '2025-11-30T00:00:00Z',
        status: 'pending',
      },
    ],
    paymentSchedule: [
      {
        id: 'pay-1',
        amount: 25000,
        dueDate: '2025-08-01T00:00:00Z',
        status: 'paid',
        paidDate: '2025-08-01T00:00:00Z',
      },
      {
        id: 'pay-2',
        amount: 25000,
        dueDate: '2025-09-15T00:00:00Z',
        status: 'paid',
        paidDate: '2025-09-15T00:00:00Z',
      },
      {
        id: 'pay-3',
        amount: 25000,
        dueDate: '2025-11-30T00:00:00Z',
        status: 'pending',
      },
    ],
    terms: 'Fixed price contract with milestone-based payments. Includes 30 days of post-launch support.',
    createdAt: '2025-07-15T10:00:00Z',
    updatedAt: '2025-10-02T14:30:00Z',
  },
  {
    id: 'contract-2',
    contractNumber: 'LWM-2025-002',
    clientId: 'client-2',
    clientName: 'Global Innovations LLC',
    projectId: 'project-2',
    projectName: 'Mobile App Development',
    type: 'milestone',
    status: 'active',
    totalValue: 120000,
    paidAmount: 40000,
    startDate: '2025-10-15T00:00:00Z',
    endDate: '2026-03-31T00:00:00Z',
    signedDate: '2025-10-01T00:00:00Z',
    deliverables: [
      {
        id: 'del-4',
        title: 'MVP Development',
        description: 'Core features and basic functionality',
        dueDate: '2025-12-15T00:00:00Z',
        status: 'in-progress',
      },
      {
        id: 'del-5',
        title: 'Advanced Features',
        description: 'Push notifications, offline mode, analytics',
        dueDate: '2026-02-15T00:00:00Z',
        status: 'pending',
      },
      {
        id: 'del-6',
        title: 'App Store Launch',
        description: 'App store submission and launch',
        dueDate: '2026-03-31T00:00:00Z',
        status: 'pending',
      },
    ],
    paymentSchedule: [
      {
        id: 'pay-4',
        amount: 40000,
        dueDate: '2025-10-15T00:00:00Z',
        status: 'paid',
        paidDate: '2025-10-15T00:00:00Z',
      },
      {
        id: 'pay-5',
        amount: 40000,
        dueDate: '2025-12-15T00:00:00Z',
        status: 'pending',
      },
      {
        id: 'pay-6',
        amount: 40000,
        dueDate: '2026-03-31T00:00:00Z',
        status: 'pending',
      },
    ],
    terms: 'Milestone-based contract with payments tied to deliverables. Includes 3 months warranty.',
    createdAt: '2025-09-20T09:00:00Z',
    updatedAt: '2025-10-03T10:15:00Z',
  },
  {
    id: 'contract-3',
    contractNumber: 'LWM-2025-003',
    clientId: 'client-4',
    clientName: 'Enterprise Systems Co',
    projectId: 'project-3',
    projectName: 'Legacy System Migration',
    type: 'hourly',
    status: 'active',
    totalValue: 200000,
    paidAmount: 100000,
    startDate: '2025-06-01T00:00:00Z',
    endDate: '2025-12-31T00:00:00Z',
    signedDate: '2025-05-25T00:00:00Z',
    deliverables: [
      {
        id: 'del-7',
        title: 'Architecture Design',
        description: 'Microservices architecture and migration plan',
        dueDate: '2025-07-15T00:00:00Z',
        status: 'completed',
      },
      {
        id: 'del-8',
        title: 'Phase 1 Migration',
        description: 'Migrate core services',
        dueDate: '2025-09-30T00:00:00Z',
        status: 'completed',
      },
      {
        id: 'del-9',
        title: 'Phase 2 Migration',
        description: 'Migrate remaining services and data',
        dueDate: '2025-12-31T00:00:00Z',
        status: 'in-progress',
      },
    ],
    paymentSchedule: [
      {
        id: 'pay-7',
        amount: 50000,
        dueDate: '2025-07-31T00:00:00Z',
        status: 'paid',
        paidDate: '2025-07-31T00:00:00Z',
      },
      {
        id: 'pay-8',
        amount: 50000,
        dueDate: '2025-09-30T00:00:00Z',
        status: 'paid',
        paidDate: '2025-09-30T00:00:00Z',
      },
      {
        id: 'pay-9',
        amount: 50000,
        dueDate: '2025-11-30T00:00:00Z',
        status: 'pending',
      },
      {
        id: 'pay-10',
        amount: 50000,
        dueDate: '2025-12-31T00:00:00Z',
        status: 'pending',
      },
    ],
    terms: 'Time and materials contract at $150/hour. Monthly invoicing with net 30 payment terms.',
    notes: 'High-priority enterprise client. Weekly status meetings required.',
    createdAt: '2025-05-10T08:00:00Z',
    updatedAt: '2025-10-02T16:45:00Z',
  },
  {
    id: 'contract-4',
    contractNumber: 'LWM-2025-004',
    clientId: 'client-6',
    clientName: 'CloudFirst Technologies',
    projectId: 'project-5',
    projectName: 'Cloud Migration',
    type: 'retainer',
    status: 'active',
    totalValue: 85000,
    paidAmount: 42500,
    startDate: '2025-08-01T00:00:00Z',
    endDate: '2025-11-15T00:00:00Z',
    signedDate: '2025-07-28T00:00:00Z',
    deliverables: [
      {
        id: 'del-10',
        title: 'Infrastructure Setup',
        description: 'AWS account setup and initial configuration',
        dueDate: '2025-08-31T00:00:00Z',
        status: 'completed',
      },
      {
        id: 'del-11',
        title: 'Data Migration',
        description: 'Migrate databases and storage to cloud',
        dueDate: '2025-10-15T00:00:00Z',
        status: 'in-progress',
      },
      {
        id: 'del-12',
        title: 'Go-Live & Optimization',
        description: 'Production cutover and performance optimization',
        dueDate: '2025-11-15T00:00:00Z',
        status: 'pending',
      },
    ],
    paymentSchedule: [
      {
        id: 'pay-11',
        amount: 21250,
        dueDate: '2025-08-01T00:00:00Z',
        status: 'paid',
        paidDate: '2025-08-01T00:00:00Z',
      },
      {
        id: 'pay-12',
        amount: 21250,
        dueDate: '2025-09-01T00:00:00Z',
        status: 'paid',
        paidDate: '2025-09-01T00:00:00Z',
      },
      {
        id: 'pay-13',
        amount: 21250,
        dueDate: '2025-10-01T00:00:00Z',
        status: 'pending',
      },
      {
        id: 'pay-14',
        amount: 21250,
        dueDate: '2025-11-01T00:00:00Z',
        status: 'pending',
      },
    ],
    terms: 'Monthly retainer with 160 hours included per month. Additional hours billed at $125/hour.',
    createdAt: '2025-07-20T09:00:00Z',
    updatedAt: '2025-10-01T15:30:00Z',
  },
  {
    id: 'contract-5',
    contractNumber: 'LWM-2025-005',
    clientId: 'client-8',
    clientName: 'FinanceFlow Solutions',
    projectId: 'project-6',
    projectName: 'Payment Gateway Integration',
    type: 'fixed-price',
    status: 'completed',
    totalValue: 55000,
    paidAmount: 55000,
    startDate: '2025-06-01T00:00:00Z',
    endDate: '2025-08-31T00:00:00Z',
    signedDate: '2025-05-28T00:00:00Z',
    deliverables: [
      {
        id: 'del-13',
        title: 'Payment Gateway Integration',
        description: 'Integrate Stripe and PayPal',
        dueDate: '2025-07-15T00:00:00Z',
        status: 'completed',
      },
      {
        id: 'del-14',
        title: 'Fraud Detection',
        description: 'Implement fraud detection rules',
        dueDate: '2025-08-15T00:00:00Z',
        status: 'completed',
      },
      {
        id: 'del-15',
        title: 'Reporting Dashboard',
        description: 'Transaction reporting and analytics',
        dueDate: '2025-08-31T00:00:00Z',
        status: 'completed',
      },
    ],
    paymentSchedule: [
      {
        id: 'pay-15',
        amount: 27500,
        dueDate: '2025-06-01T00:00:00Z',
        status: 'paid',
        paidDate: '2025-06-01T00:00:00Z',
      },
      {
        id: 'pay-16',
        amount: 27500,
        dueDate: '2025-08-31T00:00:00Z',
        status: 'paid',
        paidDate: '2025-08-31T00:00:00Z',
      },
    ],
    terms: 'Fixed price with 50% upfront and 50% on completion. Includes 60 days of support.',
    notes: 'Successfully completed. Client very satisfied.',
    createdAt: '2025-05-15T10:00:00Z',
    updatedAt: '2025-08-31T17:00:00Z',
  },
  {
    id: 'contract-6',
    contractNumber: 'LWM-2025-006',
    clientId: 'client-1',
    clientName: 'TechCorp Solutions',
    projectId: 'project-4',
    projectName: 'Analytics Dashboard',
    type: 'fixed-price',
    status: 'offer',
    totalValue: 35000,
    paidAmount: 0,
    startDate: '2025-07-15T00:00:00Z',
    endDate: '2025-09-30T00:00:00Z',
    deliverables: [
      {
        id: 'del-16',
        title: 'Dashboard Development',
        description: 'Build interactive dashboard with charts',
        dueDate: '2025-09-15T00:00:00Z',
        status: 'pending',
      },
      {
        id: 'del-17',
        title: 'Custom Reports',
        description: 'Implement custom reporting features',
        dueDate: '2025-09-30T00:00:00Z',
        status: 'pending',
      },
    ],
    paymentSchedule: [
      {
        id: 'pay-17',
        amount: 17500,
        dueDate: '2025-07-15T00:00:00Z',
        status: 'pending',
      },
      {
        id: 'pay-18',
        amount: 17500,
        dueDate: '2025-09-30T00:00:00Z',
        status: 'pending',
      },
    ],
    terms: 'Fixed price contract. Payment on start and completion.',
    notes: 'Awaiting client signature.',
    createdAt: '2025-07-01T12:00:00Z',
    updatedAt: '2025-07-05T09:30:00Z',
  },
];
